"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ReservedRegions_native_exports = {};
__export(ReservedRegions_native_exports, {
  Provider: () => Provider
});
module.exports = __toCommonJS(ReservedRegions_native_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_OneNativeReservedRegionsProviderNativeComponent = __toESM(require("../specs/OneNativeReservedRegionsProviderNativeComponent"), 1);
var import_reservedRegionsContext = require("./reservedRegionsContext");
function toRegion(region) {
  if (region.kind !== "division" && region.kind !== "occlusion") {
    throw new Error(`OneNativeReservedRegionsProvider emitted unknown kind ${region.kind}`);
  }
  return {
    id: region.id,
    kind: region.kind,
    frame: {
      x: region.x,
      y: region.y,
      width: region.width,
      height: region.height
    },
    margins: {
      top: region.marginTop,
      left: region.marginLeft,
      bottom: region.marginBottom,
      right: region.marginRight
    },
    isActive: region.isActive
  };
}
function Provider(param) {
  var { children, ...props } = param;
  var [snapshot, setSnapshot] = (0, import_react.useState)({
    regions: [],
    ready: false,
    bounds: null
  });
  var onChange = (0, import_react.useCallback)(function(event) {
    var { regions, width, height } = event.nativeEvent;
    setSnapshot({
      regions: regions.map(toRegion),
      ready: true,
      bounds: {
        width,
        height
      }
    });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_reservedRegionsContext.ReservedRegionsContext.Provider, {
    value: snapshot,
    children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_OneNativeReservedRegionsProviderNativeComponent.default, {
      ...props,
      onNativeReservedRegionsChange: onChange,
      children
    })
  });
}
//# sourceMappingURL=ReservedRegions.native.js.map
